<template>
  <div class="bind-form">
    <div class="form-content">
      <div class="form-item">
        <div class="label-input">
          <span class="label">持卡人</span>
          <input
            @blur="checkItem('name')"
            class="input-wrap"
            v-model="form.name"
            placeholder="银行卡持有人"
          />
        </div>
        <p class="error-txt">{{ errorTips.name }}</p>
      </div>
      <div class="form-item">
        <div class="label-input">
          <span class="label">身份证号</span>
          <input
            @blur="checkItem('id_card')"
            class="input-wrap"
            v-model="form.id_card"
            placeholder="持卡人身份证号码"
          />
        </div>
        <p class="error-txt">{{ errorTips.id_card }}</p>
      </div>
      <div class="form-item">
        <div class="label-input">
          <span class="label">银行卡号</span>
          <input
            @blur="queryBankName"
            class="input-wrap"
            v-model="form.bank_card"
            placeholder="银行卡号"
          />
        </div>
        <p class="error-txt">{{ errorTips.bank_card }}</p>
      </div>
      <div class="form-item">
        <div class="label-input">
          <span class="label">所属银行</span>
          <input
            @blur="checkItem('bank_name')"
            class="input-wrap"
            v-model="form.bank_name"
            placeholder="所属银行"
          />
        </div>
        <p class="error-txt">{{ errorTips.bank_name }}</p>
      </div>
      <div class="form-item">
        <div class="label-input">
          <span class="label">预留手机号</span>
          <input
            @blur="checkItem('phone')"
            class="input-wrap"
            v-model="form.phone"
            placeholder="银行卡的预留手机号"
          />
        </div>
        <p class="error-txt">{{ errorTips.phone }}</p>
      </div>
      <div class="form-item code">
        <div class="label-input">
          <div class="label">验证码</div>
          <div class="input-wrap">
            <input
              @blur="checkItem('vercode')"
              v-model="form.vercode"
              placeholder="请填写验证码"
            />
            <span
              class="btn-code"
              :class="{ 'btn-forbid': isDisabled }"
              @click="getCode"
              >{{ codeTxt }}</span
            >
          </div>
        </div>
        <p class="error-txt">{{ errorTips.vercode }}</p>
      </div>
    </div>
    <div class="btn-confirm" @click="submitForm">确认</div>
  </div>
</template>

<script>
let checkoutPhone = phone => {
  let reg = /^(0|86|17951)?(13[0-9]|15[0-9]|166|17[0-8]|18[0-9]|14[01456879]|19[0-9])[0-9]{8}$/;
  let errorPhoneTip = '';
  if (!phone) {
    errorPhoneTip = '手机号不能为空';
  } else if (!reg.test(phone)) {
    errorPhoneTip = '请输入正确的手机号';
  } else {
    errorPhoneTip = '';
  }
  return errorPhoneTip;
};
let checkoutIDCode = phone => {
  // eslint-disable-next-line max-len
  let reg = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
  let errorPhoneTip = '';
  if (!phone) {
    errorPhoneTip = '身份证号码不能为空';
  } else if (!reg.test(phone)) {
    errorPhoneTip = '请输入正确的身份证号码';
  } else {
    errorPhoneTip = '';
  }
  return errorPhoneTip;
};
let checkoutBankCard = phone => {
  let reg = /^([1-9]{1})(\d{7,25}$)/;
  let errorPhoneTip = '';
  if (!phone) {
    errorPhoneTip = '银行卡号不能为空';
  } else if (!reg.test(phone)) {
    errorPhoneTip = '请输入正确的银行卡号';
  } else {
    errorPhoneTip = '';
  }
  return errorPhoneTip;
};
import { getBankName, getBankVercode, bindBank } from '@/api/income';
import { mapState } from 'vuex';
export default {
  data() {
    return {
      form: {
        name: '',
        id_card: '',
        bank_card: '',
        bank_name: '',
        phone: '',
        vercode: '',
      },
      isDisabled: false,
      codeTxt: '获取验证码',
      errorTips: {
        name: '',
        id_card: '',
        bank_card: '',
        bank_name: '',
        phone: '',
        vercode: '',
      },
    };
  },

  computed: {
    ...mapState(['bankInfo']),
  },
  methods: {
    // 获取银行卡验证码
    async fetchBankVercode() {
      let data = {
        name: this.form.name,
        id_card: this.form.id_card,
        bank_card: this.form.bank_card,
        bank_name: this.form.bank_name,
        phone: this.form.phone,
      };
      try {
        await getBankVercode(data);
        this.$Toast.success('发送成功');
        this.countDown();
      } catch (error) {
        console.log(error);
      }
    },
    // 绑定银行卡接口
    async fetchBindBank() {
      let data = {
        name: this.form.name,
        id_card: this.form.id_card,
        bank_card: this.form.bank_card,
        bank_name: this.form.bank_name,
        phone: this.form.phone,
        vercode: this.form.vercode,
      };
      try {
        await bindBank(data);
        this.$Toast.success('操作成功');
        this.$router.push({ name: 'bindInfo', params: { update: 1 } });
      } catch (error) {
        console.log(error);
      }
    },
    // 获取银行名接口
    async fetchGetBankname() {
      try {
        const res = await getBankName({
          bank_card: this.form.bank_card,
        });
        this.form.bank_name = res.data.bank_name;
      } catch (error) {
        console.log(error);
      }
    },
    // 验证银行卡号
    queryBankName() {
      this.checkItem('bank_card');
      if (this.errorTips.bank_card == '') {
        this.fetchGetBankname();
      }
    },
    // 获取验证码
    getCode() {
      let arr = ['name', 'id_card', 'bank_card', 'bank_name', 'phone'];
      this.multipleCheck(arr);
    },
    // 倒计时
    countDown() {
      let time = 60;
      const interId = setInterval(() => {
        time--;
        if (time > 0) {
          this.codeTxt = `重新发送${time}S`;
          this.isDisabled = true;
        } else {
          clearInterval(interId);
          this.isDisabled = false;
          this.codeTxt = '获取验证码';
        }
      }, 1000);
    },
    checkItem(item) {
      let errorTxtObj = {
        name: '请输入银行卡持有人',
        bank_name: '请输入所属银行',
        vercode: '验证码不能为空',
      };
      if (item == 'id_card') {
        this.errorTips.id_card = checkoutIDCode(this.form.id_card);
      } else if (item == 'bank_card') {
        this.errorTips.bank_card = checkoutBankCard(this.form.bank_card);
      } else if (item == 'phone') {
        this.errorTips.phone = checkoutPhone(this.form.phone);
      } else {
        if (!this.form[item]) {
          for (let key in errorTxtObj) {
            if (item == key) {
              this.errorTips[item] = errorTxtObj[key];
            }
          }
        } else {
          this.errorTips[item] = '';
        }
      }
    },
    submitForm() {
      let arr = [
        'name',
        'id_card',
        'bank_card',
        'bank_name',
        'phone',
        'vercode',
      ];
      this.multipleCheck(arr);
    },
    // 同时验证多项表单内容
    multipleCheck(arr) {
      arr.forEach(item => {
        this.checkItem(item);
      });

      if (
        arr.length == 6 &&
        this.errorTips.name == '' &&
        this.errorTips.id_card == '' &&
        this.errorTips.bank_card == '' &&
        this.errorTips.bank_name == '' &&
        this.errorTips.phone == '' &&
        this.errorTips.vercode == ''
      ) {
        this.fetchBindBank();
      }
      if (
        arr.length == 5 &&
        this.errorTips.name == '' &&
        this.errorTips.id_card == '' &&
        this.errorTips.bank_card == '' &&
        this.errorTips.bank_name == '' &&
        this.errorTips.phone == ''
      ) {
        this.fetchBankVercode();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.bind-form {
  font-size: 24px;
  color: #262626;
  width: 100%;
  min-height: calc(100vh - 103px);
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  input {
    height: 56px;
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    text-indent: 15px;
    color: #bfbfbf;
  }
  .btn-code {
    background: @primaryColor;
    border-radius: 8px;
    color: #fff;
    display: flex;
    align-items: center;
    padding: 0 15px;
  }
  .btn-forbid {
    background: #d9d9d9;
  }
  .form-content {
    margin-top: 78px;
    .form-item {
      height: 56px;
      margin-bottom: 60px;
      width: 560px;
      .label-input {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .label {
        flex: 1;
        text-align: right;
        margin-right: 28px;
        font-size: 26px;
      }
      .input-wrap {
        width: 400px;
        display: flex;
        justify-content: space-between;
      }
    }
    .code {
      input {
        width: 200px;
      }
    }
  }
  .btn-confirm {
    width: 500px;
    height: 70px;
    background: #fd9b21;
    border-radius: 8px;
    color: #fff;
    text-align: center;
    line-height: 70px;
    font-size: 28px;
    margin-top: 202px;
  }
}
input::placeholder {
  color: #bfbfbf;
}
.error-txt {
  height: 30px;
  color: red;
  margin: 8px 0 0 160px;
}
input {
  -webkit-appearance: none;
}
</style>
